import "./index.scss";

export const PasswordStrengthMeter = ({ passwordScore, inputValid }) => {
  const meterStrength = () => {
    if (passwordScore === 0) return "";
    if (passwordScore < 2) {
      return "weak";
    } else if (passwordScore < 4) {
      return "fair";
    } else {
      return "good";
    }
  };

  return (
    <div className={`passwordStrengthMeter ${!inputValid && "shiftMeter"}`}>
      <div className="meter">
        <div
          data-testid="meter-strength"
          className={`passwordStrength ${meterStrength()}`}
        />
      </div>
    </div>
  );
};
